import { render, staticRenderFns } from "./ProdKnowledge.vue?vue&type=template&id=692c581b"
import script from "./ProdKnowledge.vue?vue&type=script&lang=js"
export * from "./ProdKnowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports